const addDotToICDCode = (code) => {
  const codeParts = code.split('')
  codeParts.splice(3, 0, '.')
  const valueToDisplay = codeParts.join('')
  return valueToDisplay
}

export default addDotToICDCode
